
import {Component, Vue} from "vue-property-decorator";
import BuroPersonelList from "@/components/lists/BuroPersonelList.vue";
import BuroInfo from "@/components/infos/BuroInfo.vue";
import iletisimList from "@/components/lists/IletisimList.vue";
import BankaHesabiList from "@/components/lists/BankaHesabiList.vue";
import {BuroEntity} from "@/entity/BuroEntity";
import SayfaBilgiInfo from "@/components/SayfaBilgiInfo.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import KullanimSuresiUyari from "@/components/KullanimSuresiUyari.vue";

@Component({
  components: {SayfaBilgiInfo, BuroInfo, iletisimList, BankaHesabiList, BuroPersonelList, KullanimSuresiUyari}
})

export default class BuroDetayView extends Vue {
  item: any = new BuroEntity();
  programPaths = ProgramPaths;

  oncekiSayfa(){
    this.$router.push(this.programPaths.ofispro + '/buro-bilgileri')
  }

  get action() {
    if (this.item && this.item.buro) {
      return "/api/v1/buro/" + this.item.buro.id;
    }
  }

  mounted() {
    let activeProcess = {id: this.$route.params.id, key: 'buro-detay', isRoot: true}
    this.$store.commit('setActiveProcess', activeProcess);
    this.load();
  }

  load() {
    this.$http
        .get('/api/v1/buro-detay-list/' + this.$route.params.id)
        .then(response => this.item = response.data);
  }
}
